export const iconFontAwesomeTravelHotelTractor = (
	<i className="fa-solid fa-tractor"></i>
);
